export default "__VITE_ASSET__CiNwUqx1__"